module.exports = "images/patreon-icon.png";